

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const childmenuListAtom = atom({key:'child_menu_list_Atom', default:{module_info:[],
    menu_parent_info:[],menu_child_info:[]
}});

const childMenuEditAtom = atom({key:'childMenuEditAtom', default:{}});



export  const SetChildMenuList = () => useSetRecoilState(childmenuListAtom);
export  const GetChildMenuList = () => useRecoilValue(childmenuListAtom);

export  const SetChildMenuEdit = () => useSetRecoilState(childMenuEditAtom);
export  const GetChildMenuEdit = () => useRecoilValue(childMenuEditAtom);



// export  const SetModuleEdit = () => useSetRecoilState(moduleEditAtom);
// export  const GetModuleEdit = () => useRecoilValue(moduleEditAtom);









